export default "__VITE_ASSET__Be13flkL__"